import React from 'react';
import { toast } from "react-toastify";

import i18n from "i18next";

import moment from 'moment'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-bs4' );
require( 'datatables.net-select-bs4' );
require('../../datatables.selected.css');

const columns = [
    {
        title: 'LicenseName',
        width: 100,
        data: 'LicenseName'
    },
    {
        title: 'Price',
        width: 100,
        data: 'Price'
    },
    {
        title: 'Updated',
        width: 130,
        data: 'Updated'
    },
];


interface MyProps {
    license_prices:any,
}

interface MyState {
}

class AdminLicensePricesTable extends React.Component<MyProps,MyState> {
    constructor(props) {
        super(props);

        this.state = {
        };

    }
    componentDidMount() {
        let table = $(this.refs.main).DataTable({
            dom: "<'data-table-wrapper'" +
                    "<'row'<'col-md-6'<'toolbar'>><'col-md-6'>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>" +
                    ">",
            data: this.props.license_prices,
            columns,
            ordering: true,
            paging:true,
            scrollX: false,
            // select: {
            //     style: 'single' 
            // },
            order: [[ 0, "desc" ]]
            ,language: {
                search: i18n.t("trans_33_search"),
                emptyTable:  i18n.t("trans_33_table_no_records"),
                paginate: {
                    first: i18n.t("trans_33_first"),
                    previous: i18n.t("trans_33_previous"),
                    next: i18n.t("trans_33_next"),
                    last: i18n.t("trans_33_last")
                }
            }
            ,columnDefs: [
                {
                    render: function ( data, type, row ) {
                        if(data != null && data != "0000-00-00"){
                            return moment(data).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            return "";
                        }
                    },
                    targets: 2,
                }
            ],
        });

    }

    componentWillUnmount(){
        $('.data-table-wrapper')
            .find('.licensePricesTable')
            .DataTable()
            .destroy(true);
    }

    componentDidUpdate(oldProps) {
        if(this.props.license_prices !== oldProps.license_prices){
            reloadTableData(this.props.license_prices);
        }
    }

    render() {
        return (
            <div className="row">
                <div  className="col-md-12" id="licensePricesTableContainer">
                    <table ref="main" className="table table-bordered licensePricesTable" />
                </div>
            </div>);
    }

}

function reloadTableData(items) {
    const table = $('.data-table-wrapper')
        .find('.licensePricesTable')
        .DataTable();
    table.clear();
    table.rows.add(items);
    table.draw();

    $("#deleteBtn").hide();
    $("#editBtn").hide();
}

export default AdminLicensePricesTable;
